<div id="outer" class="well container">
    @if (loading) {
        <div class="loading"></div>
    }
    <div class="col-md-12">
        <div class="well-notify"></div>
    </div>
    <div class="well-title">
        @if (!loading) {
            <div class="col-md-12">
                {{ isEditMode ? "Edit" : "Create" }} Keyword{{ isEditMode ? ` - ${keyword.Name}` : "" }}
            </div>
        }
    </div>
    <div>&nbsp;</div>
    <div class="col-md-12">
        <a class="back-link" routerLink="/configure/keywords">Back to Keywords</a>
    </div>
    <div class="col-md-12 well-content">
        <div class="panel panel-default">
            <div class="panel-heading">Keyword Details</div>
            <div class="panel-body">
                <form #frm="ngForm" class="form-horizontal">
                    <!-- seems to be faster to use a template for this -->
                    @if (!isEditMode || isBeingUsed) {
                    } @else {
                        <blockquote style="font-size: smaller">
                            This keyword has not been used and can be modified or deleted.
                        </blockquote>
                    }
                    <div class="form-group">
                        <label for="keywordName" class="col-md-2 control-label">
                            Name <span style="color: red">*</span>
                        </label>
                        <div class="col-md-4">
                            <input
                                name="keywordName"
                                type="text"
                                required
                                maxlength="255"
                                #keywordNameMdl="ngModel"
                                class="form-control"
                                [(ngModel)]="keyword.Name" />
                            @if (keywordNameMdl.touched && keywordNameMdl.invalid) {
                                <span class="text-danger"> Name is required </span>
                            }
                        </div>
                    </div>
                    <div class="form-group">
                        <label for="keywordType" class="col-md-2 control-label">
                            Type
                            @if (!isEditMode || !isBeingUsed) {
                                <span style="color: red">*</span>
                            }
                        </label>
                        <div class="col-md-4">
                            @if (isEditMode && isBeingUsed) {
                                <input
                                    id="keywordType"
                                    class="form-control"
                                    type="text"
                                    [value]="getKeywordTypeName(keyword.KeywordType)"
                                    readonly
                                    disabled />
                            } @else {
                                <nz-radio-group
                                    name="keywordType"
                                    #keywordTypeMdl="ngModel"
                                    [(ngModel)]="keyword.KeywordType"
                                    (ngModelChange)="onKeywordTypeChange($event)"
                                    nzButtonStyle="solid"
                                    nzSize="small"
                                    required>
                                    <label for="keywordType" name="keywordType" nz-radio-button [nzValue]="1"
                                        >Alphanumeric</label
                                    >
                                    <label for="keywordType" name="keywordType" nz-radio-button [nzValue]="2"
                                        >Numeric</label
                                    >
                                    <label for="keywordType" name="keywordType" nz-radio-button [nzValue]="3"
                                        >Date</label
                                    >
                                </nz-radio-group>
                                @if (keywordTypeMdl.touched && keywordTypeMdl.invalid) {
                                    <span class="text-danger"> Type is required </span>
                                }
                            }
                        </div>
                    </div>
                    <div class="form-group">
                        <label for="keywordRegex" class="col-md-2 control-label">Validation Regex</label>
                        <div class="col-md-4">
                            <input
                                id="keywordRegex"
                                name="keywordRegex"
                                class="form-control"
                                type="text"
                                #keywordRegexMdl="ngModel"
                                [(ngModel)]="keyword.Regex"
                                (ngModelChange)="onRegexChange($event)" />
                            @if (!regexValid) {
                                <span class="text-danger"> Invalid regex pattern </span>
                            }
                        </div>
                    </div>
                    @if (keyword.KeywordType === 3) {
                        <div class="form-group">
                            <label for="keywordDateFormat" class="col-md-2 control-label">Date Display Format</label>
                            <div class="col-md-4">
                                @if (isEditMode && isBeingUsed) {
                                    <input
                                        id="keywordDateFormat"
                                        class="form-control"
                                        type="text"
                                        [value]="keyword.DateFormat"
                                        readonly
                                        disabled />
                                } @else {
                                    <input
                                        id="keywordDateFormat"
                                        name="keywordDateFormat"
                                        class="form-control"
                                        type="text"
                                        maxlength="255"
                                        [(ngModel)]="keyword.DateFormat" />
                                }
                                @if (keyword.DateFormat.trim().length) {
                                    <span style="margin-left: 5px"
                                        >Format example: "{{ today | date: keyword.DateFormat }}"</span
                                    >
                                }
                            </div>
                        </div>
                    }
                </form>
            </div>
        </div>
        <button class="btn btn-default" (click)="save(frm)">Save Details</button>
        @if (keyword.Id && !isBeingUsed) {
            <button class="btn btn-danger" (click)="remove()">Delete Keyword</button>
        }
    </div>
</div>
